module.exports = __webpack_public_path__ + "static/img/stock-photo-carpenter-cutting-house-roof-supports-on-building-site-303640886.3e864fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-carpenter-cutting-house-roof-supports-on-building-site-303640886.jpg
// module id = A+u7
// module chunks = 1